<template>
	<div class="matches__container">
		<spinner v-show="refreshing" />
		<div
			v-if="$route.name != 'sport-countries'"
			:class="{
				matches: 1,
				'matches--countries__active': selectedNav == 'countries',
			}"
			v-infinite-scroll="loadMore"
			:infinite-scroll-disabled="loadingMore"
			infinite-scroll-immediate-check="false"
			infinite-scroll-distance="10"
		>
			<pull-to-refresh
				:callback="refreshMatches"
				:is-scroll-sensitive="selectedNav != 'countries'"
				:is-touch-sensitive="selectedNav != 'countries'"
				style="width: 100%"
			>
				<sports-list v-if="$store.getters.layout == 'Mobile'" />
				<prematch-nav :selectedNav="selectedNav" @changeNav="changeNav" />
				<template v-if="selectedNav != 'countries'">
					<filters
						:sport="selectedSport"
						:markets="markets"
						:currentMarket="selectedMarket"
						:sortOptions="sortOptions"
						:sortBy="sortBy"
						:periods="periods"
						:currentPeriod="selectedPeriod"
						@change-sort-option="(option) => changeSort(option)"
						@change-market="(market) => changeMarket(market)"
						@change-current-period="(period) => changePeriod(period)"
						@apply="applyFilters"
						@reset="reset"
						v-if="!esports"
					/>
					<slider :banners="env.banners" />
					<div class="selected-filters">
						<div
							class="selected-filters__item"
							v-if="
								selectedSport &&
								selectedSport.sport_id != env.defaultSport.sport_id
							"
						>
							<button
								class="selected-filters__item__action"
								@click="
									$router.push({
										name: 'sport',
										params: {
											sportName: $options.filters.seoText(
												env.defaultSport.sport_name
											),
										},
									})
								"
							>
								&times;
							</button>
							<span class="selected-filters__item__label">
								<sport-icon
									:sport="{
										sport_name: selectedSport.sport_name,
										sport_id: selectedSport.sport_id,
									}"
									class="selected-filters__item__icon"
								/>
								{{ selectedSport.sport_name | toTitleCase }}</span
							>
						</div>
						<div class="selected-filters__item" v-if="selectedNav != ''">
							<button
								class="selected-filters__item__action"
								@click="changeNav('')"
							>
								&times;
							</button>
							<span class="selected-filters__item__label">
								{{ selectedNav | toTitleCase }}
							</span>
						</div>
						<div
							class="selected-filters__item"
							v-if="selectedCompetition.competition_id"
						>
							<button
								class="selected-filters__item__action"
								@click="
									changeCompetition({
										competition_id: null,
										competition_name: null,
									})
								"
							>
								&times;
							</button>
							<h1 class="selected-filters__item__label">
								{{ selectedCompetition.competition_name | toTitleCase }}
							</h1>
						</div>
						<div class="selected-filters__item" v-if="selectedPeriod.id != -1">
							<button
								class="selected-filters__item__action"
								@click="
									changePeriod({
										id: -1,
										name: 'Today',
									})
								"
							>
								&times;
							</button>
							<span class="selected-filters__item__label">
								{{ selectedPeriod.name | toTitleCase }}
							</span>
						</div>
						<div
							class="selected-filters__item"
							v-if="selectedMarket.sub_type_id != '1,186'"
						>
							<button
								class="selected-filters__item__action"
								@click="
									changeMarket({
										sub_type_id: '1,186',
										name: '1x2',
										odd_keys: ['1', 'X', '2'],
									})
								"
							>
								&times;
							</button>
							<span class="selected-filters__item__label">
								{{ selectedMarket.name | toTitleCase }}
							</span>
						</div>
					</div>
					<match-list-loader v-show="loading || filtering" />
					<div class="matches__title" v-if="matches.length > 0">
						<span class="matches__title__teams">Teams</span>
						<div
							class="matches__title__keys"
							:number-of-odds="selectedMarket.odd_keys.length"
						>
							<div
								class="matches__title__key"
								v-for="(odd_key, i) in selectedMarket.odd_keys"
								:key="i"
							>
								{{ odd_key }}
							</div>
						</div>
					</div>
					<match
						v-for="(match, index) in matches"
						:match="match"
						:selectedMarket="selectedMarket"
						:live="false"
						:key="index"
					/>
					<match-list-loader v-show="loadingMore" />
					<empty
						v-if="matches.length == 0 && !loading && !filtering"
						:message="`There are no${
							selectedCompetition.competition_id
								? ' ' + selectedCompetition.competition_name.toLowerCase() + ' '
								: ''
						} ${
							selectedSport && selectedSport.sport_name.toLowerCase()
						} matches available ${
							selectedPeriod.id != 9 ? selectedPeriod.name.toLowerCase() : ''
						}`"
					/>
					<b-button
						v-if="page * limit > total && selectedNav != 'upcoming'"
						class="button button__secondary matches__more no-bg"
						@click="changeNav('upcoming')"
					>
						See all upcoming
						{{ selectedSport && selectedSport.sport_name.toLowerCase() }}
						matches
					</b-button>
					<b-button
						v-if="
							page * limit < total && !loading && !filtering && !loadingMore
						"
						class="button button__secondary matches__more no-bg"
						@click="loadMore"
					>
						Load more matches
					</b-button>
				</template>
			</pull-to-refresh>
		</div>
		<router-view></router-view>
	</div>
</template>
<script>
import Match from "./Match.vue";
import Spinner from "../Shared/Spinner.vue";
import SportsList from "./SportsList.vue";
import PrematchNav from "./Nav.vue";
import Slider from "../Home/Slider.vue";
import Filters from "../Shared/MatchFilters/Filters.vue";
import Countries from "./Countries.vue";
import MatchListLoader from "../Shared/MatchListLoader.vue";

export default {
	name: "prebet-matches",
	components: {
		Match,
		Spinner,
		SportsList,
		Slider,
		Filters,
		PrematchNav,
		Countries,
		MatchListLoader,
	},
	computed: {
		selectedCompetition() {
			return this.$store.getters.selectedCompetition;
		},
		selectedSport() {
			return this.$store.getters.selectedSport;
		},
	},
	data() {
		return {
			error: false,
			loading: true,
			loadingMore: false,
			filtering: false,
			page: 1,
			limit: 10,
			matches: [],
			tabs: [
				{ id: "-1", name: "Today" },
				{ id: "-2", name: "Upcoming" },
				{ id: "1", name: "Tomorrow" },
				{ id: null, name: "" },
				{ id: null, name: "" },
				{ id: null, name: "" },
			],
			periods: [
				{ id: "-1", name: "Today" },
				{ id: "-2", name: "Upcoming" },
				{ id: "1", name: "Tomorrow" },
				{ id: null, name: "" },
				{ id: null, name: "" },
				{ id: null, name: "" },
			],
			selectedPeriod: { id: "-1", name: "Today" },
			selectedTab: { id: "-1", name: "Today" },
			markets: [
				{
					name: "1x2",
					sub_type_id: "1,186",
					odd_keys: ["1", "X", "2"],
				},
			],
			selectedMarket: {
				name: "1x2",
				sub_type_id: "1,186",
				odd_keys: ["1", "X", "2"],
			},
			sortOptions: [
				{
					id: 1,
					name: "Top leagues",
				},
				{
					id: 2,
					name: "Start time",
				},
				{
					id: 3,
					name: "Top teams",
				},
			],
			sortBy: {
				id: 1,
				name: "Highlights",
			},
			tags: [{ tag_id: "", tag_title: "Top Leagues" }],
			selectedTag: { tag_id: "", tag_title: "Top Leagues" },
			total: 10,
			refreshing: false,
			countries: [],
			esports: false,
			showBanner: false,
			selectedNav: "",
			active: false,
		};
	},
	watch: {
		$route: {
			handler: function () {
				let vm = this;
				if (!vm.active) return;
				const newSport = vm.getSportFromUrl();
				const newCompetition = vm.getCompetitionFromUrl();
				if (vm.selectedSport.sport_id != newSport.sport_id) {
					vm.$store.commit("UPDATE_SELECTED_SPORT", newSport);
					vm.$store.dispatch("getCountries").then((countries) => {
						vm.$store.commit("SET_COUNTRIES", countries);
					});
				}
				if (
					vm.selectedCompetition.competition_id != newCompetition.competition_id
				) {
					vm.$store.commit(
						"UPDATE_SELECTED_COMPETITION",
						vm.getCompetitionFromUrl()
					);
				}
			},
		},
		selectedCompetition: {
			handler: function () {
				let vm = this;
				vm.$nextTick(() => {
					vm.changeCompetition();
				});
			},
		},
		selectedSport: {
			handler: function () {
				let vm = this;
				vm.$nextTick(() => {
					vm.changeSport();
				});
			},
		},
	},
	mounted() {
		let vm = this;
		vm.init();
	},
	async activated() {
		let vm = this;
		vm.active = true;
		window.addEventListener("clickHomeBottomNavEvent", () => {
			vm.handleClickHome();
		});
	},
	deactivated() {
		let vm = this;
		vm.active = false;
		window.removeEventListener("clickHomeBottomNavEvent", vm.handleClickHome);
	},
	methods: {
		async init() {
			let vm = this;
			vm.$store.commit("UPDATE_SELECTED_SPORT", vm.getSportFromUrl());
			vm.$nextTick(() => {
				vm.$store.dispatch("getCountries").then((countries) => {
					vm.$store.commit("SET_COUNTRIES", countries);
					vm.$store.commit(
						"UPDATE_SELECTED_COMPETITION",
						vm.getCompetitionFromUrl()
					);
				});
			});
			vm.getMatches();
		},
		getCompetitionFromUrl() {
			let competitionName = this.$route.params.competitionName;
			if (!competitionName)
				return {
					competition_id: null,
					competition_name: null,
				};
			let selectedCountry = this.$store.getters.countries.data.find(
				(country) => {
					return country.competitions.find((competition) => {
						return competition.urlSlug === competitionName;
					});
				}
			);
			let selectedCompetition = selectedCountry.competitions.find(
				(competition) => {
					return competition.urlSlug === competitionName;
				}
			);
			return selectedCompetition;
		},
		getSportFromUrl() {
			let sportName = this.$route.params.sportName;
			if (!sportName) return this.env.defaultSport;
			let selectedSport = this.$store.getters.sports.find((sport) => {
				return sport.sport_name.split(" ").join("-").toLowerCase() == sportName;
			});
			return selectedSport;
		},

		closeBanner() {
			sessionStorage.alreadySeenAppWeekBanner = true;
			this.showBanner = false;
		},
		handleClickHome() {
			console.log("[matches::handleClickHome] Clicked home");
			// check count
			if (this.$route.path == "/") {
				window.scroll({
					top: 0,
					left: 0,
					behavior: "smooth",
				});
			}
		},

		reset() {
			let vm = this;
			vm.selectedMarket = {
				name: "1x2",
				sub_type_id: "1,186",
				odd_keys: ["1", "X", "2"],
			};
			vm.sortBy = {
				id: 1,
				name: "Top leagues",
			};
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		getEsport(sport, refresh = false) {
			let vm = this;
			vm.esports = true;
			if (!refresh) vm.loading = true;
			let esport = vm.env.esportMapping[sport];
			let params = {
				page: 1,
				limit: 1000,
				tab: "upcoming",
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: esport,
				esports: true,
			};
			vm.$axios
				.get(`${BASE_URL}uo/matches`, { params })
				.then((response) => {
					vm.matches = response.data.data;
					vm.total = parseInt(response.data.meta.total);
					vm.loading = false;
					vm.refreshing = false;
				})
				.catch((error) => {
					vm.error = true;
					vm.loading = false;
					vm.refreshing = false;
				});
		},
		changeNav(nav) {
			let vm = this;
			vm.selectedNav = nav;
			if (nav == "quick-e") {
				this.getEsport(this.selectedSport.sport_id);
				return;
			}
			vm.esports = false;

			if (nav == "") {
				vm.changeSort({ id: 1, name: "Top leagues" });
				vm.changePeriod({ id: -1, name: "Today" });
			} else if (nav == "upcoming") {
				vm.changeSort({ id: 2, name: "Start time" });
				vm.changePeriod({ id: 9, name: "All" });
			}

			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		changeCompetition() {
			let vm = this;
			vm.page = 1;
			vm.limit = 10;
			if (vm.selectedCompetition.competition_id) vm.changeNav("upcoming");
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		changeMarket(market) {
			let vm = this;
			vm.selectedMarket = market;

			vm.applyFilters();
		},
		applyFilters() {
			let vm = this;
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		changeSort(option) {
			let vm = this;
			vm.sortBy = option;
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		changeSport() {
			let vm = this;
			vm.$store.commit(
				"UPDATE_SELECTED_COMPETITION",
				vm.getCompetitionFromUrl()
			);

			vm.page = 1;
			vm.limit = 10;
			vm.selectedMarket = {
				name: "1x2",
				sub_type_id: "1,186",
				odd_keys: ["1", "X", "2"],
			};
			vm.$nextTick(() => {
				if (vm.$refs.countries) vm.$refs.countries.getCountries();
				vm.filter();
			});
		},
		filterMarket(market) {
			let vm = this;
			vm.selectedMarket = market;

			vm.$nextTick(() => {
				vm.filter();
			});
		},
		filterTag(tag) {
			let vm = this;
			vm.selectedTag = tag;
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		filterTab(tab) {
			let vm = this;
			vm.selectedTab = tab;
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		changePeriod(period) {
			let vm = this;
			vm.selectedPeriod = period;
			vm.page = 1;
			vm.limit = 10;
			vm.$nextTick(() => {
				vm.filter();
			});
		},
		filter() {
			let vm = this;
			vm.filtering = true;
			vm.esports = false;
			let params = {
				page: vm.page,
				limit: vm.limit,
				tab: vm.selectedNav,
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: vm.selectedSport.sport_id,
				tag_id: vm.selectedTag.tag_id,
				competition_id: vm.selectedCompetition.competition_id,
				sort_id: vm.sortBy.id,
				period_id: vm.selectedPeriod.id,
				esports: vm.esports,
			};
			vm.$axios
				.get(`${BASE_URL}uo/matches`, { params })
				.then((response) => {
					vm.matches = response.data.data;
					vm.tabs = response.data.meta.tabs;
					vm.sports = response.data.meta.sports;
					vm.markets = response.data.meta.filters;
					vm.tags = response.data.meta.tags;
					vm.total = parseInt(response.data.meta.total);
					vm.periods = response.data.meta.periods;
					vm.sortOptions = response.data.meta.sort_options;
					vm.filtering = false;
				})
				.catch((error) => {
					vm.error = true;
					vm.filtering = false;
				});
		},
		loadMore() {
			let vm = this;
			if (vm.page * vm.limit > vm.total || !vm.active) return;
			vm.loadingMore = true;
			vm.page += 1;
			let params = {
				page: vm.page,
				limit: vm.limit,
				tab: vm.selectedNav,
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: vm.selectedSport.sport_id,
				tag_id: vm.selectedTag.tag_id,
				competition_id: vm.selectedCompetition.competition_id,
				sort_id: vm.sortBy.id,
				period_id: vm.selectedPeriod.id,
				esports: vm.esports,
			};
			vm.$axios
				.get(`${BASE_URL}uo/matches`, { params })
				.then((response) => {
					vm.matches = vm.matches.concat(response.data.data);
					vm.loadingMore = false;
				})
				.catch((error) => {
					vm.error = true;
					vm.loadingMore = false;
				});
		},
		getMatches() {
			let vm = this;
			let params = {
				page: vm.page,
				limit: vm.limit,
				tab: vm.selectedNav,
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: vm.selectedSport.sport_id,
				tag_id: vm.selectedTag.tag_id,
				competition_id: vm.selectedCompetition.competition_id,
				sort_id: vm.sortBy.id,
				period_id: vm.selectedPeriod.id,
				esports: vm.esports,
			};
			vm.$axios
				.get(`${BASE_URL}uo/matches`, { params })
				.then((response) => {
					vm.matches = response.data.data;
					vm.tabs = response.data.meta.tabs;
					vm.sports = response.data.meta.sports;
					vm.markets = response.data.meta.filters;
					vm.tags = response.data.meta.tags;
					vm.total = parseInt(response.data.meta.total);
					vm.periods = response.data.meta.periods;
					vm.sortOptions = response.data.meta.sort_options;
					vm.loading = false;
					vm.refreshing = false;
				})
				.catch((error) => {
					vm.error = true;
					vm.loading = false;
					vm.refreshing = false;
				});
		},
		refreshMatches(loaded = false) {
			let vm = this;
			if (vm.esports) {
				vm.getEsport(vm.selectedSport.sport_id, true);
				loaded("done");
				return;
			}
			let params = {
				page: 1,
				limit: vm.limit * vm.page,
				tab: vm.selectedNav,
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: vm.selectedSport.sport_id,
				tag_id: vm.selectedTag.tag_id,
				competition_id: vm.selectedCompetition.competition_id,
				sort_id: vm.sortBy.id,
				period_id: vm.selectedPeriod.id,
				esports: vm.esports,
			};
			vm.$axios
				.get(`${BASE_URL}uo/matches`, { params })
				.then((response) => {
					vm.matches = response.data.data;
					vm.tabs = response.data.meta.tabs;
					vm.sports = response.data.meta.sports;
					vm.markets = response.data.meta.filters;
					vm.tags = response.data.meta.tags;
					vm.total = parseInt(response.data.meta.total);
					vm.periods = response.data.meta.periods;
					vm.sortOptions = response.data.meta.sort_options;
					vm.loading = false;
					vm.refreshing = false;
					if (loaded) loaded("done");
				})
				.catch((error) => {
					vm.error = true;
					vm.loading = false;
					vm.refreshing = false;
					if (loaded) loaded("fail");
				});
		},
	},
};
</script>
<style lang="scss" scoped>
.matches {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	color: var(--black);
	width: 100%;
	margin: 0px auto;
	margin-bottom: calc(var(--padding-bottom) * 2);
	margin-top: var(--margin-top);
	padding-bottom: var(--padding-bottom);
	&__container {
		background: var(--white);
	}

	&--countries__active {
		padding-bottom: 0;
		margin-bottom: 0;
	}
	&__title {
		font-size: var(--font-small);
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		color: var(--light-black);
		font-weight: var(--font-weight-normal);
		background: var(--white);
		&__teams {
			flex-basis: 50%;
			padding: 5px;
			padding-left: 10px;
		}
		&__keys {
			flex-basis: 50%;
			display: flex;
			flex: 10;
			&[number-of-odds="2"] {
				.matches__title__key {
					width: calc(50% - 4px);
				}
			}
			&[number-of-odds="3"] {
				.matches__title__key {
					width: calc(50% - 4px);
				}
			}
		}
		&__key {
			display: block;
			padding: 5px;
			text-align: center;
			margin-right: 2px;
		}
	}
	&__more {
		margin: 10px auto;
		text-align: center;
		display: block;
	}
}
.selected-filters {
	padding: 8px 5px 0 5px;
	display: flex;
	flex-direction: row;
	align-items: center;
	background: var(--white);
	overflow-x: auto;
	@media (min-width: 1023px) {
		overflow-x: initial;
	}
	&__item {
		margin-right: 5px;
		margin-bottom: 5px;
		font-size: var(--font-small);
		border: none;
		background: var(--light-gray);
		color: var(--black);
		border-radius: 25px;
		padding: 5px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		&__action {
			padding: 0 5px 0 0;
			border: none;
			background: none;
			color: var(--black);
		}
		&__label {
			display: flex;
			flex-direction: row;
			align-items: center;
			white-space: nowrap;
			font-size: var(--font-small);
			font-weight: var(--font-weight-normal);
			margin: 0;
		}
		&__icon {
			width: 12px;
			height: 12px;
			fill: var(--black);
			margin-right: 2px;
		}
	}
}
</style>
